import React, { Component } from 'react';
import { Trans, withTranslation } from "react-i18next";
import "../../config/i18n";

import { NavLink } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import axios, { post } from 'axios';
import Slider from "react-slick";
import ls from "local-storage"; 
import { options } from "../../config/options";
import Loader from 'react-loader-spinner';  
import { Modal, ModalHeader, ModalBody, TabContent, TabPane } from 'reactstrap';
import face from "../../../src/assets/img/face@3x.png";
import Webcam from "react-webcam";
import * as ReactDom from 'react-dom'; 




class ProfilePhotoEdit extends Component {
    constructor(props) {
        super(props);
        this.imgUploader = this.imgUploader.bind(this);
        this.state = {
            dropdownOpen: false,
            user_details:'',   
            photoLoaderBreak: 0, 
            imagess:[],api_url:localStorage.getItem('api_url'),
            image:[],current_slide: 0,
            images:'',index_image:'',suc_msg:'',errors:{},
            lang: ls.get('LangKeySet') || options[0],
            langKey: ls.get('LangValue'),   
            current_value:'',afterChangeHandler:'',activeSlide2: 0,activeFirstlook:0,
            verify_type:'',selected_facreg:'',face_recognition:'',
            modal1:false,modal2:false,
            modal11:false,
            modalWebCam: false,
            webcamPic: false,
            faceId: '',
            fb_faceId: '',
            faceImage: '',
            imageType:'',
            fbpic:'',
            loaderDisplay : false,
            permissionAlert: false,
            hideCaptureBtn: false,
            fileUploaded: 'none', 
            modal6:false,
            file: require("../../assets/img/cap1.png"),
            // profileImages: ["http://localhost/howzu3.1/uploads/user/1556172175.jpeg", "http://localhost/howzu3.1/uploads/user/1555311900.jpeg", "http://localhost/howzu3.1/uploads/user/1555311781.jpeg"],
        }
        this.onFormSubmit = this.onFormSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
        this.fileUpload = this.fileUpload.bind(this)
        this.afterChangeHandler = this.afterChangeHandler.bind(this)
        this.onDeleteimage = this.onDeleteimage.bind(this)
        this.onFirstlook = this.onFirstlook.bind(this)
        this.showSelfiePopup = this.showSelfiePopup.bind(this)
        this.showUploadPopup = this.showUploadPopup.bind(this)
        this.validate = this.validate.bind(this);
        this.chooses = this.chooses.bind(this);

    }

        // Webcam process
    setRef = webcam => {
        this.webcam = webcam;
      };
      captureAgain = () => {
        this.setState({
            webcamPic : false,
            hideCaptureBtn: false
          })
      };
      saveFaceId = () => {
        console.log("saveFaceId function called");
        if(this.state.fbpic){
            console.log("EXISTS="+this.state.fbpic);
            let errors = {};
            // Phone number validation for OTP addon
            var checkImage = new FormData();
            checkImage.append('image', this.state.fbpic); 
            checkImage.append('flag', '1'); 
            axios({ 
                method: 'post', 
                url: this.state.api_url+'checkFaceImage',
                data: checkImage,
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            }).then(res => {
                console.log("check faceId");
                console.log(res.data.status);
                
                if(res.data.status === false) {  console.log(2)
                    errors["captureImg"] = res.data.message; 
                    this.setState({ 
                        loaderDisplay : false,
                        webcamPic : false,
                        //errors: errors,
                        //errorMsg:'errorMsg',
                        hideCaptureBtn: false,
                        modal6:true,
                        message: errors
                    });
                    setTimeout(() => {
                        this.setState({
                                errorMsg: 'errorMsghide'
                        });
                    }, 2000);  
                } else {console.log(3)
                    console.log("THIS GETS CALLED");
                    var fbImagecheck = new FormData();
                    fbImagecheck.append('faceId', this.state.faceId); 
                    fbImagecheck.append('faceId2', res.data.faceId); 
                    axios({ 
                        method: 'post', 
                        url: this.state.api_url+'checkFbFace',
                        data: fbImagecheck,
                        config: { headers: {'Content-Type': 'multipart/form-data' }}
                    }).then(res => {
                        if(res.data.status === "false") {  console.log(4)
                            errors["captureImg"] = "";
                            this.setState({
                                loaderDisplay : false,
                                hideCaptureBtn: true,
                                file:require("../../assets/img/cap1.png"),
                                //fbpic: '',
                                modal1: true,
                                modalWebCam : false,
                                fb_faceId: res.data.faceId,
                                errors: errors,
                                errorMsg:'errorMsg',
                            });
                            setTimeout(() => {
                                errors["captureImg_suc"] = "";
                                this.setState({
                                        errors: errors,
                                        errorMsg: 'errorMsghide'
                                });
                            }, 2000);
                        } else { console.log(5)
                            errors["captureImg"] = "";
                            this.setState({
                                loaderDisplay : false,
                                hideCaptureBtn: true,
                                file: this.state.fbpic,
                                fbpic: this.state.fbpic,
                                modal2: true,
                                modalWebCam : false,
                                fb_faceId: res.data.faceId,
                                errors: errors,
                                errorMsg:'errorMsg',
                            });
                            setTimeout(() => {
                                errors["captureImg_suc"] = "";
                                this.setState({
                                        errors: errors,
                                        errorMsg: 'errorMsghide'
                                });
                            }, 2000);
                        }
                    });  
                }
            })
        } else {console.log(6)
            console.log("This one is called");
            this.setState({
                hideCaptureBtn: true,
                //modal2:true,
                modal2: true,
                modalWebCam : false
            });
        }
    };
      capture = () => {
        var DetectRTC = require('detectrtc');
        let errors = {};
        this.setState({ 
            loaderDisplay : true,
        });
        DetectRTC.load(() =>{
            if (DetectRTC.hasMicrophone) {
                navigator.getUserMedia({ video: true },
                () => {
                    const imageSrc  = this.webcam.getScreenshot();
                    const element = React.createElement(  
                      'img',  
                      {  
                        src:imageSrc  
                      }  
                    );  
                    ReactDom.render(element, document.getElementById("capturedPhoto"));
                    // Phone number validation for OTP addon
                    var checkImage = new FormData();
                    checkImage.append('image', imageSrc); 
                    axios({ 
                        method: 'post', 
                        url: this.state.api_url+'checkFaceImage',
                        data: checkImage,
                        config: { headers: {'Content-Type': 'multipart/form-data' }}
                    }).then(res => {
                        console.log("check faceId");
                        console.log(res.data.status);
                        
                        if(res.data.status === false) {  
                            errors["captureImg"] = res.data.message; 
                            console.log("working fine...");
                            this.setState({ 
                                loaderDisplay : false,
                                webcamPic : false,
                                //errors: errors,
                                //errorMsg:'errorMsg',
                                hideCaptureBtn: false,
                                 modal6:true,
                                 message: errors
                            });
                            setTimeout(() => {
                                this.setState({
                                        errorMsg: 'errorMsghide'
                                });
                            }, 2000);  
                        } else {
                            errors["captureImg"] = "";
                            //errors["captureImg_suc"] = "Face is matched";
                            this.setState({
                                loaderDisplay : false,
                                webcamPic : true,
                                hideCaptureBtn: true,
                                verifiedImageData: res.data,
                                faceId:res.data.faceId,
                                errors: errors,
                                errorMsg:'errorMsg',
                                faceImage:res.data.userVerificationImage,

                            });
                            //alert(1)
                            setTimeout(() => {
                                errors["captureImg_suc"] = "";
                                this.setState({
                                        errors: errors,
                                        errorMsg: 'errorMsghide'
                                });
                            }, 2000);  
                        }
                    })
                },
                () => {
                    this.setState({ 
                        loaderDisplay : false,
                        permissionAlert: true,
                    });
                    console.log('Permission Denied');
                },
                );
            }
            else if(window.location.protocol !== 'https:'){
                this.setState({ 
                    loaderDisplay : false,
                    permissionAlert: true,
                });
            }
        });
      };
    imgUploader() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }
     validate(e) {
    e.preventDefault(); 
    let errors = {};    
     //console.log("fbpic="+this.state.fbpic);
        
        // if(this.state.fbpic){
            // this.setState({
            //     //activeTab: '8',
            //     file: this.state.fbpic,
            //     modalWebCam: true,
            //     imageType:"selfie"
            // });
        // }else{
            this.setState({
                modalWebCam: true,
                imageType:"selfie"
                //activeTab: '8'
            });
        // }
   
    }
    

    componentDidMount() {
        this.slider.slickGoTo('3');

        let data = new FormData();
        data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
        data.append('language', this.state.langKey); 
          
        axios({
            method: 'post',
            url: this.state.api_url+'webprofile',
            data: data, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => { 
            if(res.data.status !== false) { 
                const user_details = res.data.result;
             
                console.log(user_details);
                let verify_type='';
                // if(user_details.face_recognition===true && user_details.profile_verify=="true" && user_details.match_verify=="true"){
                if(user_details.face_recognition===true && user_details.profile_verify=="true" ){

                    verify_type='match';
                    
                }
                else if((user_details.selected_facreg==="true" || user_details.selected_facreg===true) && user_details.gallery_verify=="true"){
                    verify_type='gallery';
                    
                }
                else if(user_details.face_recognition===false){
                    verify_type='gallery';
                    
                }
                else{
                    verify_type='selfie';
                }
                // else{
                //     console.log("shouldnot be here");
                //     console.log("fr="+user_details.face_recognition+"pv="+user_details.profile_verify);
                //      console.log("gr="+user_details.gallery_verify);

                // }
                this.setState({
                    user_details: user_details,
                    image: user_details.imagess,
                    imagess: user_details.imagess,
                    verify_type:verify_type,
                    selected_facreg:user_details.selected_facreg,
                    face_recognition:user_details.face_recognition
                    //profileImages: user_details.images,
                });
                console.log("verifytype="+this.state.verify_type);
            } else { 
                this.props.history.push("/login"); 
            }
        }).catch(error => {
           this.props.history.push("/login"); 
        });
      

    }

     closeModal(tabId) {
        console.log(tabId);
        this.setState({
            [tabId]: false
        });
    }
    showSelfiePopup(){
        this.setState({
            modal11:true
        })
    }
    chooses(){
        this.setState({
            modal11:false,
            modal1:true
        })
    }
    showUploadPopup(){
        console.log("showUploadPopup called");
        this.setState({
            modal1:false,
            modal2:true,
            imageType:"gallery"
        })
console.log(this.state.modal1);
console.log(this.state.modal2);
    }
    

    onFormSubmit(e){
        //e.preventDefault() 
        this.fileUpload(this.state.images);
      }
      onChange(e) {
        this.setState({
          file: URL.createObjectURL(e.target.files[0])
        })
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
              return;
        this.createImage(files[0]);
      }
      /*createImage(file) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.setState({
            images: e.target.result
          })
        };
        reader.readAsDataURL(file);
        setTimeout(() => {
            this.onFormSubmit();
          }, 1000);
        //this.onFormSubmit();
      } */


      async createImage(file) {
        let reader = new FileReader();
        var file_err = 0;
        var err = 0;
        reader.onload = (e) => {

            this.setState({
            images: e.target.result
          })

          
                var image = new Image();
                image.src = e.target.result;
                const scope = this;
                image.onload = async function () {
                    var height = this.height;//alert(height);
                    var width = this.width;//alert(width);
                    
                    //  if ((height > 1500 || height > 1500) && (width > 1500 || width > 1500)) {
                        
                        if ((height > 4033) && (width > 4033)) {
                        file_err++;                        
                        //alert('Height and Width must not exceed 1920*400.');                        
                        err++;
                        await scope.setState({
                             suc_msg: 'errorMsg floatingAlerts1',
                             //errorMsg:'errorMsg',
                             loaderDisplay:false,
                             fileUploaded:'none',
                             //modal6:true,
                             img_validation:1                             
                        });

                    }
                    else{
                        if ((height < 500) && (width > 1500)) {
                            file_err++;                        
                        //alert('Height and Width must not exceed 1920*400.');                        
                        err++;
                        await scope.setState({
                             suc_msg: 'errorMsg floatingAlerts1',
                             //errorMsg:'errorMsg',
                             loaderDisplay:false,
                             fileUploaded:'none',
                             //modal6:true,
                             img_validation:1                             
                        });
                        }else{
                            file_err=0;  
                            await scope.setState({
                                img_validation:0
                                //modal6:false,
                                //images: e.target.result
                                
                            });
                        }
                        

                    }

            };
        };

        await reader.readAsDataURL(file);
        setTimeout(() => {
            this.onFormSubmit();
          }, 1000);
        //this.onFormSubmit();
      }   
    fileUpload(images){
        let errors = {};
        // alert(this.state.images);

if(this.state.img_validation == 0){
    if(this.state.imagess[4]  === null || this.state.imagess[4] === '' || this.state.imagess[4] === undefined){ 
        if(this.state.images === null || this.state.images === ''){
            errors["uploadimage"] = 'select a image';
            this.setState({
                errors: errors,  
                suc_msg: 'errorMsg floatingAlerts1',
            });
            setTimeout(() => {
                this.setState({
                    suc_msg: 'errorMsghide'
                });
              }, 2000);

        } else {
             this.setState({
            loaderDisplay: true,
            fileUploaded: 'upload',
        });
            if(this.state.photoLoaderBreak === 0) {   

                const url = this.state.api_url+'uploadimageweb';
                let img_type;
                if(this.state.verify_type=='match'){
                    img_type='selfie';
                    console.log("selfie");
                }
                else if(this.state.face_recognition===false || this.state.verify_type=='gallery'){
                    img_type='gallery';
                }
                else{
                    img_type=this.state.imageType;
                    console.log("img_type="+this.state.imageType);
                }
                const formData = {file: this.state.images, faceId:this.state.faceId, imagetype:img_type,user_id: JSON.parse(localStorage.getItem('session_userid')), language: this.state.langKey};   
                this.setState({
                    images:'',
                    photoLoaderBreak: 1,  

                });
                return  post(url, formData)
                .then(res => { 
                    if(res.data.status === 'true') {
                        const image_url = res.data.imageurl;
                        const image_name = res.data.image_name;
                        var editprofile = new FormData();
                        editprofile.set('images', image_url);
                        editprofile.set('images_name', image_name);
                        editprofile.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
                        editprofile.set('language', this.state.langKey);
                        editprofile.set('faceId', this.state.faceId);
                        editprofile.set('verify_type', this.state.verify_type);
                        editprofile.set('img_type', img_type);
                        editprofile.set('selected_facreg',this.state.face_recognition);
                          
                        axios({
                            method: 'post',
                            url: this.state.api_url+'websetprofile',
                            data: editprofile,
                            config: { headers: {'Content-Type': 'multipart/form-data' }}
                        }).then(res => { 
                            const message = res.data.message;
                            errors["uploadimage"] = message;

                            let data = new FormData();
                            data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
                            data.append('language', this.state.langKey); 
                               window.location.reload();    
                            axios({
                                method: 'post',
                                url: this.state.api_url+'webprofile',
                                data: data, 
                                config: { headers: {'Content-Type': 'multipart/form-data' }}
                            }).then(res => {
                                if(res.data.status !== false) {
                                     let verify_type='';
                                    const user_details = res.data.result;
                                   if(user_details.face_recognition===true && user_details.profile_verify=="true" && user_details.match_verify=="true"){
                    verify_type='match';
                    
                }
                else if((user_details.selected_facreg==="true" || user_details.selected_facreg===true) && user_details.gallery_verify=="true"){
                    verify_type='gallery';
                    
                }
                else if(user_details.face_recognition===false){
                    verify_type='gallery';
                    
                }
                else{
                    verify_type='selfie';
                }
                // else{
                //     console.log("shouldnot be here");
                //     console.log("fr="+user_details.face_recognition+"pv="+user_details.profile_verify);
                //      console.log("gr="+user_details.gallery_verify);

                // }
                            this.setState({
                                      errors: errors,  
                                      user_details: user_details,
                                      image: user_details.imagess,
                                      imagess: user_details.imagess,
                                      suc_msg: 'successMsg floatingAlerts1',
                                      images:'',
                                      current_slide : (user_details.imagess).length - 1,
                                      modal2:false,
                                      modal1:false,
                                    verify_type:verify_type,
                                    selected_facreg:user_details.selected_facreg,
                                    face_recognition:user_details.face_recognition

                                    });
                                    setTimeout(() => {
                                        this.setState({
                                            suc_msg: 'successMsghide'
                                        });
                                    }, 5000);
                                } else {  
                                    this.props.history.push("/login"); 
                                }
                            }).catch(error => {
                               this.props.history.push("/login"); 
                            }); 
                            
                        }) 

                        this.setState({
                            photoLoaderBreak: 0, 
                        });

                    } else {
                        errors["uploadimage"] = res.data.message;
                        this.setState({
                            //errors: errors,  
                            suc_msg: 'errorMsg floatingAlerts1',
                             //errorMsg:'errorMsg',
                             loaderDisplay:false,
                             fileUploaded:'none',
                              modal6:true,
                             message: errors
                        });
                        setTimeout(() => {
                            this.setState({
                                suc_msg: 'errorMsghide'
                            });
                          }, 7000);

                        this.setState({
                            photoLoaderBreak: 0,   
                        });

                    }
                   
                })
            }
        } 
    } else { 
        errors["uploadimage"] = 'Only 5 images you can upload';
        this.setState({
            errors: errors,  
            suc_msg: 'errorMsg floatingAlerts1',
        });
        setTimeout(() => {
            this.setState({
                suc_msg: 'errorMsghide'
            });
          }, 2000);

     }

     }
    else{

            this.setState({
                            //errors: errors,  
                            suc_msg: 'errorMsg floatingAlerts1',
                             //errorMsg:'errorMsg',
                             loaderDisplay:false,
                             fileUploaded:'none',
                             modal6:true,
                             
                        });
    }      
    } 
    handleChange = event => {
        const { current_value } = event.target;
        //alert(current_value);
        this.setState({ current_value });
      }; 
      handleswipe(image_tmp) {
          //alert("zsd");
          
      }
      onDeleteimage(){
        let errors = {};
          //alert(this.state.image[this.state.activeSlide2]);
            var image_url = this.state.image[this.state.activeSlide2];
            var array = this.state.image; // make a separate copy of the array 
            //console.log(this.state.activeSlide2);
            var index = this.state.activeSlide2;   
            if (index !== -1 && index !== 0) {
                array.splice(index, 1);
                this.setState({image: array});
            
                var delete_image = new FormData();
                delete_image.set('delete_image', image_url);
                delete_image.set('language', this.state.langKey); 
                delete_image.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
                axios({
                    method: 'post',
                    url: this.state.api_url+'websetprofile',
                    data: delete_image,
                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                }).then(res => {  
                    const status = res.data.status;  
                    if(status==="false"){                  
                        errors["uploadimage"] = 'Profile image cannot be deleted';
                        this.setState({
                            errors: errors,  
                            suc_msg: 'errorMsg floatingAlerts1',
                        });
                        setTimeout(() => { 
                            this.setState({
                                suc_msg: 'errorMsghide'
                            });
                        }, 3000); 
                    } else if(status==="true") {                  
                        errors["uploadimage"] = res.data.message;
                        this.setState({
                            errors: errors,  
                            suc_msg: 'successMsg floatingAlerts1',
                            modal2:false
                        });
                        setTimeout(() => {
                            this.setState({
                                suc_msg: 'successMsghide'
                            });
                          }, 3000);
                    }
                });
            } else {
                errors["uploadimage"] = 'Profile image cannot be deleted';
                this.setState({    
                    errors: errors,  
                    suc_msg: 'errorMsg floatingAlerts1',
                });
                setTimeout(() => { 
                    this.setState({
                        suc_msg: 'errorMsghide'
                    });
                }, 3000); 
            } 
      }
      onFirstlook(){
        
            var first_look = new FormData();
            first_look.set('user_image', this.state.image[this.state.activeSlide2]);
            first_look.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
            first_look.set('language', this.state.langKey);  
            axios({
                method: 'post',
                url: this.state.api_url+'websetfirstlook', 
                data: first_look,
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            })  

            let data = new FormData();
            data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
            data.append('language', this.state.langKey); 

            axios({
                method: 'post',
                url: this.state.api_url+'webprofile',
                data: data, 
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            }).then(res => {
                if(res.data.status !== false) {
                    const user_details = res.data.result;
                    
                    this.setState({
                        user_details: user_details,
                        image: user_details.imagess,
                        imagess: user_details.imagess,
                        
                    });
                    window.location.reload();  
                    // this.componentDidMount()
                } else {
                    this.props.history.push("/login"); 
                }
            }).catch(error => {
               this.props.history.push("/login"); 
            }); 
                   
        //  window.location.reload();                
        }    
        
        afterChangeHandler(currentSlide) {
            this.props.updateInitialSlide(currentSlide);
        }
    
    render() {
      
       /* const settings = {
            dots: true,
            arrows:false,
            infinite: false,
            speed: 500,
            autoplay: true, 
            slidesToShow: 1, 
            slidesToScroll: 1,
            afterChange: current => this.setState({ activeSlide2: current })  
          };*/

          var settings = {
            autoplay: true, 
            slidesToShow: 1, 
            slidesToScroll: 1,
            dots: true,
            infinite: false,
            slickGoTo: 2,
            afterChange: current => this.setState({ activeSlide2: current })
          };      
const { data, value } = this.state; 
        const { t } = this.props; 
        const videoConstraints = {
            width: 400,
            height: 720,
          facingMode: "user"
        };
        const {
          otp,
          numInputs,
          separator,
          isDisabled,
          hasErrored,
          isInputNum,
          country,
          face_rec
        } = this.state;
        var style = {
            zIndex:10,
            backgroundColor:"transparent",
            height:400,
            width:400,
            position:"absolute",
            justifyContent:"center",
            alignItems:"center",
            display: this.state.loaderDisplay === true ? "block" : "none" ,
            overflowY:"hidden"
          };
          var style1 = {
            zIndex:10,
            top: "150px",
            left: "48%",
            backgroundColor:"transparent",
            height:"100%",
            width:"100%",
            position:"absolute",
            justifyContent:"center",
            alignItems:"center",
            display: this.state.loaderDisplay === true ? "block" : "none" ,
          };
        return (

            <div className="setting-page">

                <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg amb10 ">
                    <div class="heading-left-top d-flex">
                        <div className="align-self-center ">
                            <NavLink to="/app/Profile">
                                <div className="iconHolder align-self-center mr-1">
                                    <div className="backGlow">
                                        <div className="backIco"></div>
                                    </div>
                                </div>
                            </NavLink>
                        </div>
                        <span class="arrow-center align-self-center bold-font">
                            <Trans i18nKey="Edit Photo">Edit Photo</Trans></span>
                    </div>
    
                </div>

                <div className="settingsPageWidth profileSectionView">


                    <div className="ProfileSpace ">
                   
                        <div className="peopleINSpaceHolder ">
                        {/* <p>
          AfterChange => activeSlide: <strong>{this.state.activeSlide2}</strong>
        </p> */}
                            <div className="peopleINViewHolder initialCursor">
                                <div className="peopleINPic">                                     
                                    <Slider ref={slider => (this.slider = slider)} {...settings}>
                                    {this.state.image.map((image_tmp) =>
                                        <div> <img src={image_tmp} id="current_image" alt="" value={image_tmp} onChange={()=>{this.handleswipe(image_tmp)}} className="" afterChange={this.afterChangeHandler}/></div>
                                    )}   
                                    </Slider>

                                </div>
                                <div className="apd10 apt15 ">

                                    <div className="d-flex justify-content-end apb10">
                                            {this.state.photoLoaderBreak === 0 ?
                                            this.state.verify_type==='match' || this.state.verify_type==='gallery'?
                                                <form onSubmit={this.onFormSubmit}>
                                                      <div className="circularIcoHolder addphoto">
                                                        <label className=" custom-file-upload "> +
                                                            <input id="file-upload" type="file" accept=".jpg,.jpeg,.png"  onChange={this.onChange} />
                                                        </label>
                                                      </div>    
                                                </form>
                                                :
                                                <div className="circularIcoHolder addphoto" onClick={this.showSelfiePopup} style={{cursor:'pointer'}}>
                                                        <label className="custom-file-upload"  > +
                                                       
                                                        </label>
                                                      </div>    

                                            
                                            :
                                            <div className="circularIcoHolder addphoto">    
                                                <Loader type="Bars" color="#ffffff" height={20} width={35} />
                                            </div> 
                                        }
                                            <div className={this.state.suc_msg}><Trans i18nKey={this.state.errors.uploadimage}>{this.state.errors.uploadimage}</Trans></div>
                                        <div className="circularIcoHolder">

                                        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.imgUploader}>
                                                    <DropdownToggle className="RSoverride">
                                                    <div className="circularHorizontalDotIco"></div>
                                                    </DropdownToggle>
                                                    <DropdownMenu className="dropDownRSoverride imgUploaderDropPos">
                                                       <button className={this.state.activeSlide2 === 0 ? 'border-0 bg-white text-center pointCurs primary-color' : 'border-0 bg-white text-center pointCurs'} onClick={this.onFirstlook}> 
                                                        <Trans i18nKey="First Look">First Look</Trans> 
                                                       </button> 
                                                      <button className="border-0 bg-white text-center pointCurs" onClick={this.onDeleteimage}>   
                                                        <Trans i18nKey="Delete">Delete</Trans>
                                                      </button>   
                                                    </DropdownMenu>
                                                </Dropdown> 

                                           
                                        </div> 

                                    </div>



                                </div> 
                            </div>
                        </div>



                    </div>


                </div>

            {/*selfie popup*/}

            <Modal isOpen={this.state.modal11}  className="premiumPopup modal-dialog-centered appofDay signinPagePop  apd5 par">
                    <ModalHeader><h4 class="modal-title disclaim"><Trans i18nKey="Disclaimer Information">Disclaimer Information</Trans></h4></ModalHeader>

                        <ModalBody>
                                    <div className="premiumPop apl25 apr25 apt5 apb5">

                                        <div className="row signininterest justify-content-center justify-content-lg-start setting-page">
                                        <div className="premiumBenifitOverflow">
                                        <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                                  <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="We do not allow guns, blood, nudity and unnecessary images">We do not allow guns, blood, nudity and unnecessary images</Trans></div>                                             
                                            </div>

                                            

                                            <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                                      <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="We do not allow any objects images for verification">We do not allow any objects images for verification</Trans></div>                                             
                                            </div>

                                            <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                                     <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="If the uploaded image is not clear then the image will not be accepted. So you need to re-upload the correct image">If the uploaded image is not clear then the image will not be accepted. So you need to re-upload the correct image.</Trans></div>                                              
                                            </div>

                                            <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                                        <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="After face verification you need to upload a profile picture. If this image is not similar to your selfie, it will not be accepted, so you will need to upload another image">After face verification you need to upload a profile picture. If this image is not similar to your selfie, it will not be accepted, so you will need to upload another image.</Trans></div>                                           
                                            </div>

                                            <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                                          <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="On profile upload screen popup We do not allow guns, blood, nudity and unnecessary images"> On profile upload screen popup We do not allow guns, blood, nudity and unnecessary images</Trans></div>                                             
                                            </div>

                                            <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                                         <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="If above mentioned verification is not satisfactory then we will show proper alert">If above mentioned verification is not satisfactory then we will show proper alert</Trans></div>                                            
                                            </div>

                                        </div>
                                        </div>
                                      
                                        <div className="sidebarLastContent text-center" data-toggle="modal" data-target="#next-page">
                                            <button className="btn-common btn-block" onClick={this.chooses}><Trans i18nKey="Next">Next</Trans></button>
                                        </div>

                                    </div>
                                </ModalBody>
                    </Modal>

                <Modal isOpen={this.state.modal1}  className="premiumPopup modal-dialog-centered appofDay signinPagePop  apd5 par">
                    <ModalHeader  className="apk-24 d-none"></ModalHeader>

                    <div>
                                <ModalBody className="selfie_popup_modalbody">
                               
                                <div class="premiumPop" style={{width:"70%",margin:"0 auto"}} >
                                <img src={face} alt="" class="img-fluid" />
                            </div>
                            <div class="sidebarLastContent selfie_popup_custom_style text-center">
                                <button className="btn-common btn-block" onClick={this.validate}><Trans i18nKey="Take Selfie by Camera">Take Selfie by Camera</Trans></button>

                                    </div>
                                    <div class="sidebarLastContent selfie_popup_custom_style text-center">
                                        <button className="btn-common btn-block" onClick={this.showUploadPopup} ><Trans i18nKey="Upload the profile image by Gallery">Upload the profile image by Gallery</Trans></button>

                                            </div>
                                </ModalBody>
                    </div>
                    </Modal>
                     {/*image upload popup*/}
                <Modal isOpen={this.state.modal2}  className="premiumPopup modal-dialog-centered appofDay signinPagePop  apd5 par">
                    <ModalBody>
                                <div className="signStepSecondWrapper relPos">
                                    <div className="centerImgSelecting photo-rotation">
                                        <label className=" custom-file-upload" >
                                            <form onSubmit={this.onFormSubmit}>
                                                <input type="file" onChange={this.onChange} accept=".jpg,.jpeg,.png" style={{opacity:"0"}} />
                                                <img id="image1" src={this.state.file} alt="" />
                                            </form>
                                        </label>
                                        <div className="loder-icon">
                                            <div style={style1} id="loader_profile">
                                                <Loader type="Bars" color="#ca2a1e" height={30} width={50} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="blueBannerSignIn"> <div className="text-center apk-30 text-light pt-2"><Trans i18nKey="Upload great photos">Upload great photos</Trans></div></div>
                                    <div style={{ height: "180px" }}></div>
                                    <div className={this.state.errorMsg} style={{ paddingLeft: "25px" }}>
                                        <Trans i18nKey={this.state.errors.uploadimage}>{this.state.errors.uploadimage}</Trans>
                                    </div> 
                                    <div className="successMsg" style={{ paddingLeft: "25px" }}>

                                    <p> <Trans i18nKey="Kindly upload the image within height 1000">Kindly upload the image within height 1000</Trans> </p>
                                    
                                        <Trans i18nKey={this.state.errors.uploadimage_suc}>{this.state.errors.uploadimage_suc}</Trans>   
                                    </div>
                                    <div className="d-flex justify-content-between apd25 apb15">
                                        <span id="next" style={{display:"none"}} className="apk-18 bold-font pointCurs" onClick={() => { this.toggle('3'); }}><Trans i18nKey="Next">Next</Trans></span>
                                        { (this.state.fileUploaded === "none") ?
                                            
                                            <form onSubmit={this.onFormSubmit}>
                                                <span className="apk-18 bold-font pink-color">
                                                <label className=" custom-file-upload primary-color"> <Trans i18nKey="Add Photos">Add Photos</Trans>
                                                <input id="file-upload" type="file" accept=".jpg,.jpeg,.png" onChange={this.onChange} />
                                                </label></span>
                                                
                                            </form>
                                            : ''
                                        }  
                                    </div>
                                    
                                </div>
                                </ModalBody>
                    
                    </Modal>
                    {/*  Webcam popup */}
                            <Modal isOpen={this.state.modalWebCam} className="premiumPopup modal-dialog-centered vertically-center apd5">
                                <ModalHeader className="headerCap"><div className="webcamHead"><Trans i18nKey="Take your image">Take your image</Trans></div>
                                <p className="custom_head"><Trans i18nKey="Please upload your selfie image to verify your profile, this picture will not show in profile page">Please upload your selfie image to verify your profile, this picture will not show in profile page</Trans></p>
                                </ModalHeader>
                                <ModalBody className="photoPopup">  
                                    <center>    
                                        <div className="loder-icon">
                                            <div style={style} id="loader">
                                                <Loader type="Bars" color="#ca2a1e" height={30} width={50} />
                                            </div>
                                        </div>  
                                        <div className="blueimgCap">                
                                            <Webcam
                                            audio={false}
                                            forceScreenshotSourceSize="true"
                                            ref={this.setRef}
                                            mirrored
                                            screenshotFormat="image/jpeg"
                                            videoConstraints={videoConstraints}
                                            style={{ display: this.state.webcamPic === false ? 'block' : 'none' }}
                                            />
                                            <div id="capturedPhoto" style={{ display: this.state.webcamPic === true ? 'block' : 'none' }}>   
                                            </div>
                                            <div className="webcamAlert" style={{ display: this.state.permissionAlert === true ? 'block' : 'none' }}><Trans i18nKey="Kindly allow your webcam Permission">Kindly allow your webcam Permission</Trans></div>
                                        </div>
                                        <div style={{"height" : "180px"}}></div>
                                        <div className={this.state.errorMsg} style={{ paddingLeft: "25px" }}>
                                            <Trans i18nKey={this.state.errors.captureImg}>{this.state.errors.captureImg}</Trans>
                                        </div> 
                                        <div className="successMsg" style={{ paddingLeft: "25px" }}>
                                        <p> <Trans i18nKey="Kindly upload the image within height 1000">Kindly upload the image within height 1000</Trans> </p>
                                            <Trans i18nKey={this.state.errors.captureImg_suc}>{this.state.errors.captureImg_suc}</Trans>   
                                        </div>
                                            <button onClick={this.captureAgain} className="retake-photo" style={{ display: this.state.hideCaptureBtn === true ? 'block' : 'none' }}><Trans i18nKey="Retake">Retake</Trans></button>
                                            <button onClick={this.capture} className="cap-photo" style={{ display: this.state.hideCaptureBtn === false ? 'block' : 'none' }}><Trans i18nKey="Capture photo">Capture photo</Trans></button>
                                            <button onClick={this.saveFaceId} className="cap-photo" style={{ display: this.state.hideCaptureBtn === true ? 'block' : 'none' }}><Trans i18nKey="Next">Next</Trans></button>
                                        
                                    </center>
                                </ModalBody>
                            </Modal>

                             {/*<Modal isOpen={this.state.modal6} toggle={this.closeModal.bind(this, 'modal6')} className="premiumPopup vertically-center apd5 welcome">
                    <ModalHeader toggle={this.closeModal.bind(this, 'modal6')}><h4 class="modal-title disclaim" style={{'marginTop':"10px"}}> Your photo has been rejected</h4></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div class="d-flex justify-content-end">
                                    <div className="form-group">
                                         Cause of reason : <Trans i18nKey={this.state.message}>{this.state.message}</Trans>
                                    </div>
                                <div class="mr-3"><br/><br/><button class="border-0 bg-white pink-color" onClick={this.closeModal.bind(this, 'modal6')}><Trans i18nKey="Ok">Ok</Trans></button></div>
                            </div>
                        </div>
                    </ModalBody> 
                </Modal> */}

                <Modal isOpen={this.state.modal6} className="premiumPopup modal-dialog-centered vertically-center apd5">
                                <ModalHeader><h4 class="modal-title disclaim"><Trans i18nKey="Cause of Rejection">Cause of Rejection</Trans></h4></ModalHeader>

                                <ModalHeader><h4 class="modal-title disclaim photo"><Trans i18nKey="Your Photo has been rejected">Your Photo has been rejected</Trans></h4>

                                <hr class="hr" style={{
                                            color: '#ca2a1e',
                                            backgroundColor: '#ca2a1e',
                                            height: .3,
                                            borderColor : '#ca2a1e',
                                            
                                        }}/></ModalHeader>
                                        
                                <ModalBody >
                                    <div className="premiumPop apl25 apr25 apt5 apb5">

                                        <div className="row signininterest justify-content-center justify-content-lg-start setting-page">
                                        <div className="premiumBenifitOverflow">
                                        <div className="form-group">
                                             
                                       <div className=""><Trans i18nKey="Your photo was rejected for one of the following reasons">Your photo was rejected for one of the following reasons:</Trans></div>                                             
                                            </div>                                          

                                            <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                        <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="Photo of poor quality (sharpness, brightness)">Photo of poor quality (sharpness, brightness).</Trans></div>                                            
                                            </div>

                                            <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                         <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="Indecent photo ex.shirtless, neckline too pronounced">Indecent photo (ex: shirtless, neckline too pronounced ...).</Trans></div>                                            
                                            </div>

                                            <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                            <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="Photo montage or photo containing a phone number">Photo montage or photo containing a phone number.</Trans></div>                                           
                                            </div>

                                            <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                        <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="Celebrity photo, child photo without adult(s)">Celebrity photo, child photo without adult(s).</Trans></div>                                             
                                            </div>

                                            <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                            <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="Photo containing no faces or upside down">Photo containing no faces or upside down.</Trans></div>                                           
                                            </div>

                                            <div className="form-group">
                                             <div class="tickIco mr-2"></div>
                                            <div className= {this.state.langKey == 'ar' ? "amll36" : "amll35"}><Trans i18nKey="Good quality photos are essential">Good quality photos are essential</Trans></div>                                              
                                            </div>

                                        </div>
                                        </div>
                                      
                                        
                                <center><button onClick={this.closeModal.bind(this, 'modal6')} className="capphoto" ><Trans i18nKey="Ok">Ok</Trans></button> </center>

                                    </div>
                                </ModalBody>
                            </Modal>

            </div>

        );
    }
}
 
export default withTranslation("translations")(ProfilePhotoEdit); 
